import React, {  useMemo} from "react";
import { MdClose} from "react-icons/md";
import { IconButton, Typography } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

function isPinned() {
  return ["Enable", "Disable"];
}

const DataPlanConfig = (props) => {
  const {
    currentValue,
    valueGeneral,
    index,
    onChangeConfigType,
    onChangePinColunm,
    onClickDelete,
  } = props;

  const getValueName = useMemo(() => {
    const valueName = valueGeneral.filter((item) => item.colunmName !== currentValue.colunmName ?? item.colunmName)
    const valueNameData = valueName.filter((item1) => item1.colunmName !== 'Nhân viên phụ trách' && item1.colunmName !== 'Phân công xử lý' && item1.colunmName !== 'Handle Step' && item1.colunmName !== 'Step' && item1.colunmName !== 'Người xử lý' && item1.colunmName !== 'Tình trạng' )
    return valueNameData.map((item) => item.colunmName)
    // eslint-disable-next-line 
  }, [valueGeneral])

  return (
    <div className="row rowPlanConfig">
      <div className="col-md-3">
        <Autocomplete
          id="combo-box"
          // disableCloseOnSelect
          options={getValueName}
          size="small"
          style={{ width: "100%" }}
          renderInput={(params) => (
            <TextField
              {...params}
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              label="Tên Trường"
              variant="outlined"
            />
          )}
          renderOption={(option) => (
            <Typography noWrap style={{ fontSize: "13px" }}>
              {option}
            </Typography>
          )}
          onChange={(e, newValue) => onChangeConfigType(newValue)}
          value={currentValue.colunmName ? currentValue.colunmName : null}
        />
      </div>
      <div className="col-md-3">
        {currentValue.colunmName !== "" && (
          <Autocomplete
            options={isPinned()}
            size="small"
            getOptionLabel={(option) => option}
            style={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="dense"
                label="Đóng băng cột"
                variant="outlined"
              />
            )}
            renderOption={(option) => (
              <Typography noWrap style={{ fontSize: "14px" }}>
                {option}
              </Typography>
            )}
            onChange={(e, newValue) =>
              onChangePinColunm(newValue, currentValue.colunmName)
            }
            value={currentValue.pinColunm === true ? "Enable" : "Disable"}
            // disabled={value.disabled}
          />
        )}
      </div>
      <div className="btn-handle">
        {/* <IconButton
          // disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-up-config"
          // onClick={() => props.onClickUp(props.index)}
        >
          <MdArrowUpward />
        </IconButton> */}
        {/* <IconButton
          // disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-down-config"
          // onClick={() => props.onClickDown(props.index)}
        >
          <MdArrowDownward />
        </IconButton> */}
        <IconButton
          // disabled={props.value.disabled}
          size="small"
          aria-label=""
          className="btn-delete-config"
          onClick={() => onClickDelete({currentValue, index})}
        >
          <MdClose />
        </IconButton>
      </div>
    </div>
  );
};

export default DataPlanConfig;
